import { render, staticRenderFns } from "./TypeEditor.vue?vue&type=template&id=48867d5c"
import script from "./TypeEditor.vue?vue&type=script&lang=js"
export * from "./TypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports